import React from "react";

import "./ErrorBanner.css";

import { WarningRound } from "./../../Common/Svg";

export default (props) => {
  const dismissClickHandler = () => {
    props.closeBanner();
  };

  const [headerHeight, setHeaderHeight] = React.useState(105);

  React.useEffect(() => {
    const currentHeaderHeight = document.querySelector("header").clientHeight;
    if (currentHeaderHeight < 125 && currentHeaderHeight > 100) {
      setHeaderHeight(currentHeaderHeight);
    }
  }, []);

  return (
    <div
      className="error-banner__container"
      automationid="SalesLeads_Div_wb_1"
      style={{ top: headerHeight }}
    >
      <div className="error-banner__main-body">
        <div className="error-banner__msg-container">
          <WarningRound />
          <div className="error-banner__msg" automationid="SalesLeads_Div_wb_2">
            {props.message}
          </div>
        </div>
        <button
          className="error-banner__button"
          automationid="SalesLeads_Button_wb_1"
          onClick={dismissClickHandler}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};
